import { useDispatch } from 'react-redux'

import { addNotification } from 'reducers/notification'
import { NOTIFICATION_TYPE_ERROR } from 'constants/notification'

export const useFetchDownload = () => {
  const dispatch = useDispatch()
  const fetchDownload = async (url) => {
    try {
      // only fetch headers first, not the whole downloaded file
      const response = await fetch(url, {
        method: 'HEAD',
        credentials: 'include',
      })

      if (response.status === 200) {
        window.location.href = url
      } else {
        // get error text from response json body
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
        })
        const json = await response.json()

        dispatch(addNotification({
          text: json?.message?.text || 'error',
          type: json?.message?.type || NOTIFICATION_TYPE_ERROR,
          shouldClearOnLocationChange: true,
          hideRefreshLink: true,
        }))
      }
    } catch (e) {
      dispatch(addNotification({
        text: 'file download error',
        type: NOTIFICATION_TYPE_ERROR,
        hideRefreshLink: true,
      }))
      console.error(e)
    }
  }
  return fetchDownload
}
